// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1qQyg","amount":"Amount_amount__3gIWE","tip":"Amount_tip__19Utu","tipHeader":"Amount_tipHeader__2tYIj","tipsWrap":"Amount_tipsWrap__y4uzH"};